// @flow
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 70px;
`;

export const H1 = styled.h1`
  font-size: 50px;
  font-family: ${props => props.theme.fontBold};
  font-weight: bold;
`;



// WEBPACK FOOTER //
// ./src/pages/error/error.styles.js